import { faBug } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

import JSONRender from '@/components/JSONRender/JSONRender';
import { CopyContent } from '@/ui';
import Toggle from '@/ui/components/Form/Toggle';

import CollapsibleView from './CollapsibleView';
import { Props } from './types';

const Debug = ({ object, buttonClassName = 'absolute bottom-0 right-0.5' }: Props) => {
  const [showDebugData, toggleShowDebugData] = useState<boolean>(false);
  const [showAsJson, setShowAsJson] = useState<boolean>(false);
  const [showNull, setShowNull] = useState<boolean>(true);
  const [expandAll, setExpandAll] = useState<boolean>(false);

  return (
    <div>
      {showDebugData && (
        <div className="mb-4 space-y-2">
          <div className="flex items-center gap-4">
            <Toggle
              enabled={showAsJson}
              onChange={setShowAsJson}
              label="Show as JSON"
              primaryColor="green"
            />
            {!showAsJson && (
              <>
                <Toggle
                  enabled={showNull}
                  onChange={setShowNull}
                  label="Show empty values"
                  primaryColor="green"
                />
                <Toggle
                  enabled={expandAll}
                  onChange={setExpandAll}
                  label="Expand all"
                  primaryColor="green"
                />
              </>
            )}
            <CopyContent content={JSON.stringify(object, null, 2)}>{''}</CopyContent>
          </div>
          {showAsJson ? (
            <JSONRender jsonObject={object} />
          ) : (
            <CollapsibleView data={object} showNull={showNull} expandAll={expandAll} />
          )}
        </div>
      )}

      <div className={buttonClassName}>
        <button
          aria-label="Show debug data"
          onClick={() => toggleShowDebugData(!showDebugData)}
          type="button">
          <FontAwesomeIcon
            icon={faBug}
            className={`hover:text-slate-600 text-xs ${
              showDebugData ? 'text-emerald-500' : 'text-slate-300'
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default Debug;
